import * as THREE from "three"
import { SVGLoader } from "three/examples/jsm/Addons"

export class Flame{
	group : THREE.Group
	scene : THREE.Scene
	life_deduction_callback: Function

	interval_id: number;

	constructor(scene: THREE.Scene, callback: Function){
		this.interval_id = -1;
		this.group = new THREE.Group();
		this.scene = scene;

		this.life_deduction_callback = callback;

		const loader = new SVGLoader();

		loader.load("flame.svg", ( data ) => {

			this.group.scale.multiplyScalar( 0.04 );
			this.group.rotateOnAxis(new THREE.Vector3(0,0,1), THREE.MathUtils.degToRad(180));
			
			// Always at the same position
			this.group.position.x = 1.5;
			this.group.position.y = 28.5;
			this.group.position.z = 10;
			let renderOrder = 0;

			for ( const path of data.paths ) {

				const fillColor = path.userData.style.fill;

				if ( fillColor !== 'none' ) {

					const material = new THREE.MeshBasicMaterial( {
						color: new THREE.Color().setStyle( fillColor ),
						opacity: path.userData.style.fillOpacity,
						transparent: true,
						side: THREE.DoubleSide,
						depthWrite: false,
					} );

					const shapes = SVGLoader.createShapes( path );

					for ( const shape of shapes ) {

						const geometry = new THREE.ShapeGeometry( shape );
						const mesh = new THREE.Mesh( geometry, material );
						mesh.renderOrder = renderOrder ++;

						this.group.add( mesh );
					}

				}
				else{
					console.log("Fill colour is none.");
				}
				this.group.visible = false;
				this.scene.add(this.group);
			}
		});
	}

	decrement_lives = () =>{
		clearInterval(this.interval_id);
		console.log("Flame calling decrement interval id " + this.interval_id);
		this.life_deduction_callback();
		if(this.group.visible){
			this.interval_id = setInterval(this.decrement_lives, 1000);
		}
		else{
			this.interval_id = 0;
		}

	}

	show = () => {
		this.group.visible = true;
		// If not already running, start the interval
		if(this.interval_id == 0){
			this.interval_id = setInterval(this.decrement_lives, 1000);
		}
	}
	hide = () => {
		this.group.visible = false;
		clearInterval(this.interval_id);
		this.interval_id = 0;
	}

}